export const REQUEST_ALTERNATE_EMAILS = 'REQUEST_ALTERNATE_EMAILS';
export const RECEIVE_ALTERNATE_EMAILS = 'RECEIVE_ALTERNATE_EMAILS';
export class RequestAlternateEmails {
    constructor() {
        this.type = REQUEST_ALTERNATE_EMAILS;
    }
}
export class ReceiveAlternateEmails {
    constructor(emails) {
        this.emails = emails;
        this.type = RECEIVE_ALTERNATE_EMAILS;
    }
}
